export default __webpack_public_path__ + "static/media/github.9e078e99.svg";